import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../api/axiosInstance';
import useAuthStore from '../store/useAuthStore';

const usePermissions = (moduleId) => {
  const { user } = useAuthStore();

  const pid = user?.plantID;
  const uid = user?.loginID;

  const { data, isLoading } = useQuery({
    queryKey: ['permissions', pid, uid],
    queryFn: async () => {
      try {
        console.log(`Fetching permissions for User: ${uid} at Plant: ${pid}`);
        const response = await axiosInstance.get(`/plants/${pid}/roles/user/${uid}`);
        console.log('Full API response:', response);
        // Handle both direct array and object with data property
        if (Array.isArray(response)) {
          return response;
        } else if (response && Array.isArray(response.data)) {
          return response.data;
        } else if (response && response.data && Array.isArray(response.data.data)) {
          return response.data.data;
        } else {
          return [];
        }
      } catch (error) {
        console.error("API Error in permissions:", error);
        return [];
      }
    },
    enabled: !!pid && !!uid,
    staleTime: 5 * 60 * 1000,
  });

  if (isLoading) {
    return { canAdd: false, canEdit: false, canDelete: false, isLoading: true };
  }

  const permissionsList = Array.isArray(data) ? data : [];
  console.log('Permissions List:', permissionsList);
  const moduleRole = permissionsList.find((r) => Number(r.modules) === Number(moduleId));
  console.log('Module Role for moduleId', moduleId, ':', moduleRole);

  return {
    canAdd: moduleRole?.addRecord === 'Y',
    canEdit: moduleRole?.editRecord === 'Y',
    canDelete: moduleRole?.deleteRecord === 'Y',
    isLoading: false,
  };
};

export default usePermissions;